/**
 * forgot_password_controller.js — password-reset request form behaviour (Stimulus).
 *
 * Scoped to the forgot-password <form>. Handles the submit spinner that the page
 * used to wire with an end-of-body getElementById + addEventListener (which breaks
 * / stacks after a Turbo <body> swap). The flash-message popup logic that lived in
 * the old inline <script> is gone: the public shell now includes
 * components/flash_messages.html globally, so it is handled centrally.
 *
 * The form keeps data-turbo="false" — a successful request triggers a server-side
 * redirect (and a reset email), so submit is intentionally a full navigation; the
 * spinner shows until unload.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        onSubmit() {
            var btn = this.element.querySelector('#resetBtn');
            var spinner = this.element.querySelector('#resetSpinner');
            if (!btn) return;
            btn.disabled = true;
            if (spinner) spinner.classList.remove('d-none');
            btn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Sending Link...';
        }
}
